export default __webpack_public_path__ + "static/media/kitchen3-afterE-2048w.96997d6d.avif";